import style from "../../scss/export.module.scss";

type TIcon = {
    color?: string;
    size?: number;
    className?: string;
    stroke?: string;
    strokeWidth?: number;
    colorOpacity?: number;
};

const defaultIconSettings: TIcon = {
    color: style.blackColor,
    size: 18,
    className: "",
    stroke: "",
    strokeWidth: undefined,
    colorOpacity: undefined,
};

export default defaultIconSettings;
